module.exports = __webpack_public_path__ + "img/e556490.svg";